<div class="map-title">{{title}}</div><img class="main-chart" src="{{image}}">